import { clamp, isArray } from 'lodash-es'

export type Interval<T> = [T, T]
export type NumInterval = Interval<number>

export function tryParseInt(value: unknown): number | undefined {
  if (typeof value === 'number' && !isNaN(value)) {
    return value
  }

  const result = value ? parseInt(String(value)) : NaN

  return !isNaN(result) ? result : undefined
}

export function normalizeInt(value: unknown, min: number, max: number) {
  return clamp(tryParseInt(value) ?? min, min, max)
}

export function tryParseFloat(value: unknown): number | undefined {
  const result =
    typeof value === 'number' ? value : value ? parseFloat(String(value)) : NaN
  return !isNaN(result) ? result : undefined
}

export function range(from: number = 1, to: number): number[] {
  from = Math.max(1, from)
  return Array.from({ length: to - from + 1 }, (_, i) => i + from)
}

export function positiveMod(value: number, modulus: number): number {
  return ((value % modulus) + modulus) % modulus
}

export function isNumInterval(value: unknown): value is NumInterval {
  return isArray(value) && value.length === 2 && value.every(Number.isFinite)
}

export function isNumIntervalEmpty(interval: NumInterval | number[]): boolean {
  return interval.every((value) => value === 0)
}
